import { PlaceMedia } from './get'


export const URL = '/v2/pms/accomodations/:placeId/media/:imgId/rotate/'

export type Req = void

export type Resp = PlaceMedia